module.exports = __webpack_public_path__ + "img/AirPlay.0026705b.png";